import axios from "axios"
 
const Token = localStorage.getItem("Token")
 
//live url:https://support-system.vibhohcm.com/api/
//staging url:https://staging.support-system.vibhohcm.com/api/
 
const createAxiosInstance = (token) => {
  return axios.create({
    baseURL: "https://support-system.vibhohcm.com/api/",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
}
 
export const instance = createAxiosInstance(Token)
 
export const updateToken = (newToken) => {
  // Create a new axios instance with the updated token
  instance.defaults.headers["Authorization"] = `Bearer ${newToken}`
}
 
export const noauthinstance = axios.create({
  baseURL: "https://support-system.vibhohcm.com/api/",
  headers: {
    Accept: "application/json",
  },
})